"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REAL_ESTATE = void 0;
exports.REAL_ESTATE = {
    hy: {
        DEVELOPER_REAL_ESTATE: 'ansharzh-guik-karucapatoghic-',
        REAL_ESTATE: 'ansharzh-guik-',
    },
    ru: {
        DEVELOPER_REAL_ESTATE: 'nedvizhimost-ot-zastroishika-',
        REAL_ESTATE: 'nedvizhimost-',
    },
    en: {
        DEVELOPER_REAL_ESTATE: 'new-development-',
        REAL_ESTATE: 'real-estate-',
    },
};
